import { useState, useEffect } from 'react'
import { Table, Button, Dropdown } from 'react-bootstrap';
import Api from 'helpers/Api';
import Loader from 'components/misc/Loader';
import moment from 'moment';
import { Envelope, Pencil, PlusCircle, Printer } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import PriceValue from 'components/partials/PriceValue';

function Index(props) {

    const navigate = useNavigate();

    const defaultData = {
        rows: []
    };

    const [state, setState] = useState({
        data: defaultData,
        loading: false,
    });

    useEffect(() => {
        setState(prev => ({
            ...prev,
            loading: true
        }));

        Api.get('documents/show', {
            params: {
                id: props.id
            }
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: res.data,
                loading: false,
            }));
        });
    }, [props.id]);

    const handleEdit = () => {
        navigate('/protocols/' + state.data.id + '/edit');
    }

    const handlePrint = () => {
        window.open(state.data.stream_url);
    }

    const sendMail = () => {
        props.sendMail(state.data);
    }

    const handleCreateNewVersion = () => {
        props.newVersion();
    }

    const handleCreateAccount = () => {
        props.hide();

        navigate('/accounts/new?from_document_id=' + state.data.id);
    }

    const handleCreateStoreLoad = () => {
        props.hide();

        navigate('/storage/loads/new?from_document_id=' + state.data.id);
    }

    const handleCreateOrder = () => {
        props.hide();

        navigate('/orders/new?from_document_id=' + state.data.id);
    }

    const handleCreateDocument = () => {

    }

    return (

        state.loading
            ?
            <Loader />
            :
            <>
                <Table size="sm" bordered>
                    <tbody>
                        <tr>
                            <td className="th">
                                Протокол
                            </td>
                            <td>
                                {state.data.id}
                            </td>
                            <td className="th">
                                Създал
                            </td>
                            <td>
                                {state.data?.creator?.username}
                            </td>
                            <td className="th">
                                Създадено на
                            </td>
                            <td>
                                {state.data.created_at ? moment(state.data.created_at).format('DD.MM.YYYY HH:mm') : ''}
                            </td>
                        </tr>
                        <tr>
                            <td className="th">
                                Отговорник
                            </td>
                            <td>
                                {state.data.owner?.username}
                            </td>
                            <td className="th">
                                Клиент
                            </td>
                            <td>
                                {state.data.client?.name}
                            </td>
                            <td className="th">
                                Статус
                            </td>
                            <td style={{ backgroundColor: state.data.status?.background }}>
                                {state.data.status?.name}
                            </td>
                        </tr>
                        <tr>
                            <td className="th">
                                Вальор
                            </td>
                            <td>
                                {state.data.value_date ? moment(state.data.value_date).format('DD.MM.YYYY HH:mm') : ''}
                            </td>
                            <td className="th">
                                Док. номер
                            </td>
                            <td colSpan={3}>
                                {state.data.no}
                            </td>
                        </tr>
                        <tr>
                            <td className="th">
                                Име на документа
                            </td>
                            <td colSpan={3}>
                                {state.data.document_name}
                            </td>
                            <td className="th">
                                Шаблон
                            </td>
                            <td>
                                {state.data.is_template ? 'ДА' : 'НЕ'}
                            </td>
                        </tr>
                        <tr>
                            <td className="th">
                                Бележки
                            </td>
                            <td colspan={5}>
                                {state.data.description}
                            </td>
                        </tr>
                    </tbody>
                </Table>

                <div className="mt-3">
                    <Button size="sm" variant="primary" onClick={() => handleEdit()}>
                        <Pencil /> Редактиране
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => handlePrint()} style={{ marginLeft: '10px' }}>
                        <Printer /> Печат
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => sendMail()} style={{ marginLeft: '10px' }}>
                        <Envelope /> Изпращане
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => handleCreateNewVersion()} style={{ marginLeft: '10px' }}>
                        <PlusCircle /> Нова версия
                    </Button>
                    <Dropdown drop="down" style={{ display: 'inline' }}>
                        <Dropdown.Toggle size="sm" style={{ marginLeft: '10px' }}>
                            Направи...
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="start" style={{ padding: '15px', width: '150px' }}>
                            <Button size="sm" variant="primary" onClick={() => handleCreateAccount()} style={{ width: '100%' }}>
                                Сметка
                            </Button>
                            <br />
                            <Button size="sm" variant="primary" onClick={() => handleCreateStoreLoad()} style={{ width: '100%', marginTop: '10px' }}>
                                Зареждане
                            </Button>
                            <br />
                            <Button size="sm" variant="primary" onClick={() => handleCreateOrder()} style={{ width: '100%', marginTop: '10px' }}>
                                Клиентска заявка
                            </Button>
                            {/* <br />
                            <Button size="sm" variant="primary" onClick={() => handleCreateDocument()} style={{ width: '100%', marginTop: '10px' }}>
                                Документ (TODO)
                            </Button> */}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <Table className="mt-3 xxl" size="sm" bordered>
                    <thead>
                        <tr>
                            <th style={{ width: '5%' }}>
                                ID
                            </th>
                            <th>
                                Артикул
                            </th>
                            <th className="text-right">
                                Количество
                            </th>
                            <th className="text-right">
                                Ед. цена
                            </th>
                            <th className="text-right">
                                Общо
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {state.data.rows.map(r =>
                            <tr key={r.id}>
                                <td>
                                    {r.article_id}
                                </td>
                                <td>
                                    {r?.article?.article_name}
                                </td>
                                <td className="text-right">
                                    {r.quantity} {r?.article?.amount_type_short}
                                </td>
                                <td className="text-right">
                                    <PriceValue prefix={r.currency?.prefix} sufix={r.currency?.sufix}>{r.current_price}</PriceValue>
                                </td>
                                <td className="text-right">
                                    <PriceValue prefix={r.currency?.prefix} sufix={r.currency?.sufix}>{r.total_sum}</PriceValue>
                                </td>
                            </tr>
                        )}
                        <tr className="total">
                            <td colSpan={4}>
                                Всичко
                            </td>
                            <td className="text-right">
                                <PriceValue prefix={state.data.currency?.prefix} sufix={state.data.currency?.sufix}>{state.data.total_sum}</PriceValue>
                            </td>
                        </tr>
                    </tbody>
                </Table>

            </>
    )
}

export default Index;